// CustomerProfileMobile.tsx - Mobile Layout with Simplified Tabs
import { Box, Paper, Stack, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Customer } from "../../store/services/customerService";
import Communications from "../customer-contacts/v2/Communications";
import NextActionCard from "../next-action/NextActionCard";
import CustomerNotesCard from "./components/CustomerNotesCard";
import MixedTimeline from "./components/MixedTimeline";
import QuickInfoCard from "./components/QuickInfoCard";

interface CustomerProfileMobileProps {
  customer: Customer;
  isCompany?: boolean;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      sx={{ pt: 2 }}
    >
      {value === index && children}
    </Box>
  );
}

const CustomerProfileMobile = ({
  customer,
  isCompany,
}: CustomerProfileMobileProps) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ position: "sticky", top: 0, zIndex: 1 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          aria-label="customer profile tabs"
        >
          <Tab label="Översikt" />
          <Tab label="Kontakter" />
          <Tab label="Tidslinje" />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <Stack spacing={3}>
          <QuickInfoCard customer={customer} />
          <CustomerNotesCard customerNo={customer.CustomerNo} />
          <NextActionCard customerNo={customer.CustomerNo} />
        </Stack>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <Communications
          customerNo={customer.CustomerNo}
          isCompany={isCompany}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <Stack spacing={3}>
          <MixedTimeline customerNo={customer.CustomerNo} />
        </Stack>
      </TabPanel>
    </Box>
  );
};

export default CustomerProfileMobile;
